export const flexOptions = ['OptionalFlexRate', 'FreeCancellation', 'FreeRebooking', 'PaidCancellation'] as const;